import { IFullPlanDetailPPO } from "../../../interfaces/api";
import PPODoubleInfoBenefit from "./PPODoubleInfoBenefit.component";
import {
  getDoubleDataPPO,
  getDoubleDeepPPO,
} from "../../../functions/planDetails";
import PPODoubleDeepInfoBenefit from "./PPODoubleDeepInfoBenefit.component";
import { useZipRootLoaderData } from "../../../hooks/useZipRootLoaderData";

const PPODataTableDetailMentalHealth = ({
  data,
}: {
  data: IFullPlanDetailPPO;
}) => {
  const { selectedYear } = useZipRootLoaderData();
  const getInpatientHospitalPsyhiatricBenefit = getDoubleDataPPO(
    data,
    "Inpatient Hospital Psychiatric"
  );
  const getMentalSpecPPOBenefit =
    selectedYear === 2024
      ? getDoubleDataPPO(
          data,
          "Mental Health Specialty Services (Individual and Group)"
        )
      : getDoubleDataPPO(data, "Mental Health Specialty Services");
  const getMentalServicesPPOBenefit =
    selectedYear === 2024
      ? getDoubleDeepPPO(
          data,
          "Mental Health Services",
          "Psychiatric Services (Individual and Group)"
        )
      : getDoubleDeepPPO(
          data,
          "Mental Health Services",
          "Psychiatric Services (Individual and Group)"
        );
  return (
    <div
      className="grid-x"
      style={{
        backgroundColor: "white",
        border: "1px solid #D3E1F0",

        textAlign: "left",
      }}
    >
      <div
        className="grid-x hide-for-small-only"
        style={{
          backgroundColor: "#F5F9FD",

          width: "100%",
          padding: "32px 20px",
          borderBottom: "1px solid #D3E1F0",
        }}
      >
        <div
          className="cell small-4"
          style={{
            fontSize: "25px",
            fontWeight: 600,
          }}
        ></div>
        <div
          className="cell small-4"
          style={{
            fontSize: "25px",
            fontWeight: 600,
          }}
        >
          In-Network
        </div>
        <div
          className="cell small-4"
          style={{
            fontSize: "25px",
            fontWeight: 600,
            paddingLeft: 20,
          }}
        >
          Out-of-Network
        </div>
      </div>
      <div
        className="grid-x show-for-small-only"
        style={{
          backgroundColor: "#F5F9FD",

          width: "100%",
          padding: "32px 10px",
          borderBottom: "1px solid #D3E1F0",
        }}
      >
        <div className="cell small-4"></div>
        <div
          className="cell small-4"
          style={{
            fontSize: "20px",
            fontWeight: 600,
          }}
        >
          In-Network
        </div>
        <div
          className="cell small-4"
          style={{
            fontSize: "20px",
            fontWeight: 600,
          }}
        >
          Out-of-Network
        </div>
      </div>
      <PPODoubleInfoBenefit
        benefit={getInpatientHospitalPsyhiatricBenefit}
        title="Inpatient Hospital - Psychiatric"
      />
      <PPODoubleInfoBenefit
        benefit={getMentalSpecPPOBenefit}
        title="Mental Health Speciality"
      />{" "}
      <PPODoubleDeepInfoBenefit
        benefit={getMentalServicesPPOBenefit}
        title="Psychiatric Services"
        splitInout={true}
      />
    </div>
  );
};

export default PPODataTableDetailMentalHealth;
